import React, { useState, useEffect } from 'react';
import { Plus, Trash2, X, Save } from 'lucide-react';
import api from '../../api';
import { toast } from 'sonner';
import { Input } from './NewsManager';
import ImageUpload from './ImageUpload';
import { resolveImg } from '../../api';

const GalasManager = () => {
  const [galas, setGalas] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ year: '', title: '', photos: [], videoUrl: '' });

  const load = () => api.get('/galas').then((r) => setGalas(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (editing === 'new') await api.post('/galas', form);
      else await api.put(`/galas/${editing}`, form);
      toast.success('Gala enregistré');
      setEditing(null); load();
    } catch (e) { toast.error('Erreur'); }
  };
  const remove = async (id) => {
    if (!window.confirm('Supprimer ce gala ?')) return;
    await api.delete(`/galas/${id}`); toast.success('Supprimé'); load();
  };

  const addPhoto = () => {
    if ((form.photos || []).length >= 6) return;
    setForm({ ...form, photos: [...(form.photos || []), ''] });
  };
  const updatePhoto = (i, v) => { const p = [...form.photos]; p[i] = v; setForm({ ...form, photos: p }); };
  const removePhoto = (i) => setForm({ ...form, photos: form.photos.filter((_, idx) => idx !== i) });

  return (
    <div data-testid="galas-manager">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-white">Galas de fin d'année</h2>
        <button onClick={() => { setForm({ year: '', title: '', photos: [], videoUrl: '' }); setEditing('new'); }} className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-fuchsia-500 to-pink-500 rounded-lg text-white font-medium"><Plus size={18} /> Ajouter un gala</button>
      </div>

      <div className="grid gap-4">
        {galas.map((g) => (
          <div key={g.id} className="min-w-0 flex items-center gap-4 bg-white/5 border border-white/10 rounded-xl p-4">
            {g.photos[0] && <img src={resolveImg(g.photos[0])} alt="" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" />}
            <div className="flex-1 min-w-0">
              <span className="text-fuchsia-400 font-bold">{g.year}</span>
              <h3 className="text-white font-semibold truncate">{g.title}</h3>
              <p className="text-white/50 text-sm truncate">{g.photos.length} photo(s)</p>
            </div>
            <div className="flex items-center gap-1 flex-shrink-0">
              <button onClick={() => { setForm(g); setEditing(g.id); }} className="px-3 py-1 text-white/70 hover:text-fuchsia-400" data-testid={`edit-gala-${g.id}`}>Modifier</button>
              <button onClick={() => remove(g.id)} className="p-2 text-white/60 hover:text-red-400" data-testid={`delete-gala-${g.id}`}><Trash2 size={16} /></button>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-6 overflow-y-auto">
          <div className="bg-neutral-900 border border-white/10 rounded-2xl p-8 w-full max-w-2xl my-8">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-bold text-white">Gala</h3>
              <button onClick={() => setEditing(null)} className="text-white/60 hover:text-white"><X size={24} /></button>
            </div>
            <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
              <div className="grid grid-cols-2 gap-4">
                <Input label="Année" value={form.year} onChange={(v) => setForm({ ...form, year: v })} placeholder="2026" />
                <Input label="Titre" value={form.title} onChange={(v) => setForm({ ...form, title: v })} />
              </div>
              <Input label="Lien vidéo YouTube" value={form.videoUrl} onChange={(v) => setForm({ ...form, videoUrl: v })} placeholder="https://youtube.com/watch?v=..." />
              <div>
                <div className="flex items-center justify-between mb-2">
                  <label className="text-white/70 text-sm">Photos ({(form.photos || []).length}/6)</label>
                  {(form.photos || []).length < 6 && (
                    <button type="button" onClick={addPhoto} className="text-fuchsia-400 text-sm flex items-center gap-1"><Plus size={14} /> Ajouter une photo</button>
                  )}
                </div>
                {form.photos.map((p, i) => (
                  <div key={i} className="flex items-start gap-2 mb-3 border border-white/10 rounded-lg p-3">
                    <div className="flex-1"><ImageUpload value={p} onChange={(v) => updatePhoto(i, v)} label={`Photo ${i + 1}`} /></div>
                    <button onClick={() => removePhoto(i)} className="p-2 text-white/60 hover:text-red-400"><Trash2 size={16} /></button>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex gap-3 mt-6">
              <button onClick={save} data-testid="save-gala-btn" className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-fuchsia-500 to-pink-500 rounded-lg text-white font-medium"><Save size={18} /> Enregistrer</button>
              <button onClick={() => setEditing(null)} className="px-6 py-3 bg-white/5 border border-white/10 rounded-lg text-white/70">Annuler</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GalasManager;
